import { Button, CircularProgress } from '@paysense-india-services/elevate-web'

import styles from './index.module.scss'

const formatDate = dateStr => {
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}

const formatAmount = amount => {
  return `₹${Number(amount).toLocaleString('en-IN')}`
}

const EmiScheduleItem = ({ data, onSeeBreakdown }) => {
  const progress = data?.meta?.percentage ? parseInt(data.meta.percentage, 10) : 0

  return (
    <div className={`${styles.emiItem}  ew-border-bottom`}>
      <div className='ew-d-flex ew-align-items-center ew-gap-12'>
        <CircularProgress progress={progress} size={36} />
        <span className='ew-typography-small'>{formatDate(data?.emi_date)}</span>
      </div>
      <div className={styles.rightSection}>
        <span className='ew-typography-normal ew-fw-semi-bold'>{formatAmount(data?.amount)}</span>
        {data?.actions?.primary?.text ? (
          <Button
            className={` ew-color-brand ew-p-0 ${styles.breakdownLink}`}
            onClick={() => onSeeBreakdown?.(data)}
            variant='link'>
            {data.actions.primary.text}
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export default EmiScheduleItem
